import {
    TOP_INBOUND_LANES_REQUEST,
    TOP_OUTBOUND_LANES_REQUEST,
    TOP_INBOUND_LANES_SUCCESS,
    TOP_OUTBOUND_LANES_SUCCESS,
    TOP_INBOUND_LANES_FAILURE,
    TOP_OUTBOUND_LANES_FAILURE
} from '../../actions/marketInsights/topInboundAndOutboundLanesActions';

interface TopInboundAndOutboundLanes {
    topInboundLanes: any;
    topOutboundLanes: any;
    isFetchingTopInboundLanes: boolean;
    isFetchingTopOutboundLanes: boolean;
}

const fetchTopInboundAndOutboundLanesReducer = (topInboundAndOutboundLanesData: TopInboundAndOutboundLanes = {
    isFetchingTopInboundLanes: false,
    isFetchingTopOutboundLanes: false,
    topInboundLanes: [],
    topOutboundLanes: []
}, action: any): TopInboundAndOutboundLanes => {
    switch (action.type) {
        case TOP_INBOUND_LANES_REQUEST: {
            return {
                ...topInboundAndOutboundLanesData,
                isFetchingTopInboundLanes: true
            };
        }
        case TOP_OUTBOUND_LANES_REQUEST: {
            return {
                ...topInboundAndOutboundLanesData,
                isFetchingTopOutboundLanes: true
            };
        }
        case TOP_INBOUND_LANES_SUCCESS: {
            return {
                ...topInboundAndOutboundLanesData,
                isFetchingTopInboundLanes: false,
                topInboundLanes: action.payload
            };
        }
        case TOP_OUTBOUND_LANES_SUCCESS: {
            return {
                ...topInboundAndOutboundLanesData,
                isFetchingTopOutboundLanes: false,
                topOutboundLanes: action.payload
            };
        }
        case TOP_INBOUND_LANES_FAILURE: {
            return {
                ...topInboundAndOutboundLanesData,
                isFetchingTopInboundLanes: false,
                topInboundLanes: []
            };
        }
        case TOP_OUTBOUND_LANES_FAILURE: {
            return {
                ...topInboundAndOutboundLanesData,
                isFetchingTopOutboundLanes: false,
                topOutboundLanes: []
            };
        }
        default:
            return topInboundAndOutboundLanesData;
    }
};

export default fetchTopInboundAndOutboundLanesReducer;
